var _path, _path2, _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyTable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 481,
    height: 135,
    viewBox: "0 0 481 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M320.378 18.0393C320.378 13.2048 324.297 9.28564 329.131 9.28564H471.379C476.214 9.28564 480.133 13.2048 480.133 18.0394V89.1632C480.133 93.9978 476.214 97.917 471.379 97.917H329.131C324.297 97.917 320.378 93.9978 320.378 89.1632V18.0393Z",
    fill: "url(#paint0_linear_770_21268)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M160.622 18.0393C160.622 13.2048 156.703 9.28564 151.869 9.28564H9.6208C4.78627 9.28564 0.867111 13.2048 0.867111 18.0394V89.1632C0.867111 93.9978 4.78629 97.917 9.62082 97.917H151.869C156.703 97.917 160.622 93.9978 160.622 89.1632V18.0393Z",
    fill: "url(#paint1_linear_770_21268)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 58.9939,
    r: 55.8049,
    fill: "#DDE4F2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 205.954,
    y: 0.531738,
    width: 70.4205,
    height: 30.5598,
    rx: 6.56528,
    fill: "#666B7E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 205.954,
    y: 36.4062,
    width: 70.4205,
    height: 80.3856,
    rx: 6.56528,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 17.9373,
    height: 4.65041,
    rx: 2.3252,
    transform: "matrix(1 0 0 -1 213.926 13.8188)",
    fill: "#C2B9FA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 29.2311,
    height: 4.65041,
    rx: 2.3252,
    transform: "matrix(1 0 0 -1 213.926 25.1128)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 17.9373,
    height: 4.65041,
    rx: 2.3252,
    transform: "matrix(1 0 0 -1 213.926 47.0361)",
    fill: "#5444F2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 17.9373,
    height: 4.65041,
    rx: 2.3252,
    transform: "matrix(1 0 0 -1 213.926 72.2808)",
    fill: "#5444F2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 17.9373,
    height: 4.65041,
    rx: 2.3252,
    transform: "matrix(1 0 0 -1 213.926 97.5269)",
    fill: "#5444F2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 29.2311,
    height: 4.65041,
    rx: 2.18843,
    transform: "matrix(1 0 0 -1 213.926 58.3291)",
    fill: "#E2E7E9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 29.2311,
    height: 4.65041,
    rx: 2.18843,
    transform: "matrix(1 0 0 -1 213.926 83.5752)",
    fill: "#E2E7E9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 29.2311,
    height: 4.65041,
    rx: 2.18843,
    transform: "matrix(1 0 0 -1 213.926 108.82)",
    fill: "#E2E7E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M219.169 107.794L229.662 97.302L250.647 118.287C253.544 121.184 253.544 125.882 250.647 128.779C247.749 131.677 243.052 131.677 240.154 128.779L219.169 107.794Z",
    fill: "#ABB4C5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M219.169 107.794L229.662 97.302L237.531 105.171L227.039 115.664L219.169 107.794Z",
    fill: "#91969E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M182.437 60.6036C169.399 73.5873 169.399 94.7322 182.437 107.716C195.476 120.7 216.614 120.7 229.654 107.716C242.693 94.7322 242.693 73.5873 229.654 60.6036C216.614 47.6198 195.476 47.6198 182.437 60.6036ZM190.307 68.3937C198.999 59.8615 213.09 59.8615 221.786 68.3937C230.477 77.2969 230.477 91.3936 221.786 99.9258C213.09 108.458 198.999 108.458 190.307 99.9258C181.615 91.3936 181.615 77.2969 190.307 68.3937Z",
    fill: "#CDD1DA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M229.917 84.7158C229.917 91.1109 227.377 97.244 222.855 101.766C218.333 106.288 212.2 108.829 205.805 108.829C199.41 108.829 193.276 106.288 188.754 101.766C184.232 97.244 181.692 91.1109 181.692 84.7158C181.692 78.3207 184.232 72.1875 188.754 67.6655C193.276 63.1435 199.41 60.603 205.805 60.603C212.2 60.603 218.333 63.1435 222.855 67.6655C227.377 72.1875 229.917 78.3207 229.917 84.7158Z",
    fill: "#F9FBFF",
    fillOpacity: 0.64
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_770_21268",
    x1: 338.979,
    y1: 57.431,
    x2: 480.133,
    y2: 54.1484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDE4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDE4F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_770_21268",
    x1: 142.021,
    y1: 57.431,
    x2: 0.867119,
    y2: 54.1484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDE4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDE4F2",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTable);
export default __webpack_public_path__ + "static/media/empty-table.fd209a0b4a47637f6106e4711ca44c46.svg";
export { ForwardRef as ReactComponent };